import { useKeycloak } from './useKeycloak';

export function useAuth() {
  const { authenticated, initialized, userInfo, logout } = useKeycloak();

  return {
    ready: initialized,
    authenticated,
    user: userInfo,
    logout,
  };
}
